import { render, staticRenderFns } from "./DCheckIcon.vue?vue&type=template&id=66b9605c"
import script from "./DCheckIcon.vue?vue&type=script&lang=js"
export * from "./DCheckIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports